import React, { useEffect, useState } from 'react'
import { Dropdown, Spinner } from 'react-bootstrap'
import DashBoardSideBar from "../navigation/dashBoardSideBar"
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { FaCircleCheck } from "react-icons/fa6";
import Actions from '../../store/actions';
import { LogoutApp } from '../../utils/logout';
function DashboardLoadingLayout(props) {
   let navigate = useNavigate();
   let dispatch = useDispatch();
   let brands = useSelector(data => data.brands);
   let profile = useSelector(data => data.profile);
   let appBlocked = useSelector(data => data.appBlocked);
   let categories = useSelector(data => data.categories);
   let products = useSelector(data => data.products);
   let orders = useSelector(data => data.orders);
   let locations = useSelector(data => data.locations);
   let dashboard = useSelector(data => data.dashboard);
   let users = useSelector(data => data.users);
   let contactUs = useSelector(data => data.contactUs);
   return (
      <>
         {appBlocked?.blocked ? <>
            <div className="d-flex flex-column align-items-center justify-content-center h-screen">
               <div>
                  <p className='text-center px-2'>{appBlocked?.message}</p>
               </div>
               <div>
                  <button className='btn btn-dark rounded-0' onClick={() => {
                     LogoutApp()
                  }}>Login Here</button>
               </div>
            </div>
         </> : <>
            {(profile?.loaded && brands?.loaded && categories?.loaded && products?.loaded && locations?.loaded && dashboard?.loaded && users?.loaded) ? props.children : (
               <>
                  <div className="d-flex flex-column align-items-center justify-content-center h-screen">
                     <div className="p-4 rounded text-center card " style={{ minWidth: '300px', maxWidth: '400px', }}>
                        <h4 className="mb-3">Preparing Your Dashboard...</h4>
                        <p className="text-muted mb-4">Please wait while we load your data.</p>
                        <div className="text-start">
                           <div className="d-flex align-items-center mb-1">
                              <div className="me-2">
                                 {profile?.loaded && <FaCircleCheck className="text-success" />}
                                 {profile?.loading && <Spinner variant="dark" animation="border" size="sm" />}
                              </div>
                              <small>Profile details</small>
                           </div>
                           <div className="d-flex align-items-center mb-1">
                              <div className="me-2">
                                 {dashboard?.loaded && <FaCircleCheck className="text-success" />}
                                 {dashboard?.loading && <Spinner variant="dark" animation="border" size="sm" />}
                              </div>
                              <small>Dashboard details</small>
                           </div>
                           <div className="d-flex align-items-center mb-1">
                              <div className="me-2">
                                 {brands?.loaded && <FaCircleCheck className="text-success" />}
                                 {brands?.loading && <Spinner variant="dark" animation="border" size="sm" />}
                              </div>
                              <small>Brands list</small>
                           </div>
                           <div className="d-flex align-items-center mb-1">
                              <div className="me-2">
                                 {categories?.loaded && <FaCircleCheck className="text-success" />}
                                 {categories?.loading && <Spinner variant="dark" animation="border" size="sm" />}
                              </div>
                              <small>Category list</small>
                           </div>
                           <div className="d-flex align-items-center mb-1">
                              <div className="me-2">
                                 {products?.loaded && <FaCircleCheck className="text-success" />}
                                 {products?.loading && <Spinner variant="dark" animation="border" size="sm" />}
                              </div>
                              <small>Products list</small>
                           </div>
                           <div className="d-flex align-items-center mb-1">
                              <div className="me-2">
                                 {orders?.loaded && <FaCircleCheck className="text-success" />}
                                 {orders?.loading && <Spinner variant="dark" animation="border" size="sm" />}
                              </div>
                              <small>Orders list</small>
                           </div>
                           <div className="d-flex align-items-center mb-1">
                              <div className="me-2">
                                 {contactUs?.loaded && <FaCircleCheck className="text-success" />}
                                 {contactUs?.loading && <Spinner variant="dark" animation="border" size="sm" />}
                              </div>
                              <small>Contact us list</small>
                           </div>
                           <div className="d-flex align-items-center mb-1">
                              <div className="me-2">
                                 {locations?.loaded && <FaCircleCheck className="text-success" />}
                                 {locations?.loading && <Spinner variant="dark" animation="border" size="sm" />}
                              </div>
                              <small>Location list</small>
                           </div>
                           <div className="d-flex align-items-center">
                              <div className="me-2">
                                 {users?.loaded && <FaCircleCheck className="text-success" />}
                                 {users?.loading && <Spinner variant="dark" animation="border" size="sm" />}
                              </div>
                              <small>Users list</small>
                           </div>
                        </div>
                     </div>
                  </div>
               </>
            )}
         </>}
      </>
   );
}

export default DashboardLoadingLayout